export default "__VITE_ASSET__DX4ulCl0__"